export default "__VITE_ASSET__Dumwv1Jx__"